import { Vendor } from "0.Mine/0.Components/CRM/Leads/TaskModal";
import { UserLicense } from "0.Mine/3.Interfaces/license";

import { AdditionalParams, QlickupActions, useQlickupAPI } from "../APICall";

export const useHandlePermissions = () => {
  const { QlickUpAPI } = useQlickupAPI();

  const createUserLicense = async (businessId: number, data: Partial<UserLicense>) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "addpermission",
        data,
        "permissions",
        QlickupActions.POST
      );

      return response.id as string;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getAllLicenses = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getpermissions",
        null,
        "permissions",
        QlickupActions.GET
      );
      console.log(response);
      return response.collaborators as UserLicense[];
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getVendors = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getvendors",
        null,
        "getvendor",
        QlickupActions.GET
      );
      console.log(response);
      return response.users as Vendor[];
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getSinglePermission = async (businessId: number, collaboratorId: string) => {
    const additionalParams: AdditionalParams = {
      id: collaboratorId,
    };

    const response = await QlickUpAPI(
      businessId.toString(),
      "getpermission",
      null,
      "permissions",
      QlickupActions.GET,
      additionalParams
    );

    console.log(response);

    return response.collaborator.permissions;
  };

  const editPermissions = async (businessId: number, collaboratorId: string, data: any) => {
    const additionalParams: AdditionalParams = {
      id: collaboratorId,
    };

    const response = await QlickUpAPI(
      businessId.toString(),
      "editpermission",
      data,
      "permissions",
      QlickupActions.POST,
      additionalParams
    );

    console.log(response);
  };

  const deletePermission = async (businessId: number, collaboratorId: string) => {
    const additionalParams: AdditionalParams = {
      id: collaboratorId,
    };

    const response = await QlickUpAPI(
      businessId.toString(),
      "deletepermission",
      null,
      "permissions",
      QlickupActions.POST,
      additionalParams
    );

    console.log(response);
  };

  return {
    createUserLicense,
    getAllLicenses,
    getVendors,
    getSinglePermission,
    editPermissions,
    deletePermission,
  };
};
